module.exports = __webpack_public_path__ + "static/media/vanta.8507363c.mp3";